import classNames from 'classnames';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import NoResultIcon from './SVG/NoResultIcon';

const NoResult: FC<{
  wrapperClassName?: string;
}> = ({ wrapperClassName }) => {
  const { t } = useTranslation();
  return (
    <div
      className={classNames(
        'text-center flex flex-col items-center justify-center border border-primary-100 flex-1 rounded-xl py-10',
        wrapperClassName,
      )}
    >
      <NoResultIcon />
      <p className="text-xl font-semibold">{t('list_no_result')}</p>
    </div>
  );
};
export default NoResult;
